export default function AboutSection() {
  return (
    <section id="sobre" className="py-20 bg-gradient-to-br from-[#1e3a8a]/5 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-[#c53030]/10 rounded-full">
              <span className="text-[#c53030] font-semibold text-sm">Sobre Nós</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-6">
              Especialistas em Aluguel de Vans em Orlando
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Somos uma empresa especializada em aluguel de vans e veículos para famílias brasileiras que visitam Orlando e a região da Disney. Com anos de experiência, entendemos perfeitamente as necessidades das famílias em viagem.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-8">
              Nossa missão é proporcionar conforto, segurança e economia para que você aproveite ao máximo sua viagem dos sonhos. Todos os nossos veículos são modernos, bem mantidos e equipados com tudo que você precisa.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="text-4xl font-bold text-[#c53030] mb-2">50+</div>
                <p className="text-gray-600 font-semibold">Famílias Atendidas</p>
              </div>
              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="text-4xl font-bold text-[#c53030] mb-2">5.0</div>
                <p className="text-gray-600 font-semibold">Avaliação Média</p>
              </div>
              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="text-4xl font-bold text-[#c53030] mb-2">24/7</div>
                <p className="text-gray-600 font-semibold">Suporte Disponível</p>
              </div>
              <div className="text-center p-6 bg-white rounded-xl shadow-lg">
                <div className="text-4xl font-bold text-[#c53030] mb-2">100%</div>
                <p className="text-gray-600 font-semibold">Satisfação</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/00180f47a9405d02346ddb9683136ba1.jpg"
                alt="Nossa frota"
                className="w-full h-full object-cover object-center"
              />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-2xl p-6 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-[#c53030] rounded-full">
                  <i className="ri-shield-check-line text-3xl text-white"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-lg">Seguro Total</p>
                  <p className="text-sm text-gray-600">Proteção completa incluída</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
